import SurveyService from "../services/SurveyService";

export default class Survey {
  constructor() {
    this.service = new SurveyService();
  }
}
